import { Lock, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Vises i stedet for 404 eller cryptisk fejl når en bruger uden adgang
 * lander på en beskyttet side (fx /admin/medarbejdere/{id} som medarbejder).
 *
 * Props:
 *  - title:  overskrift  (default: "Adgang begrænset")
 *  - message: forklarende tekst (default for superadmin-only)
 *  - role:   "superadmin" | "admin" (bruges til at vælge default-besked)
 */
export default function AccessDenied({ title, message, role = "superadmin" }) {
  const navigate = useNavigate();
  const defaultMsg = role === "admin"
    ? "Denne side er kun tilgængelig for admins. Kontakt en admin eller superadmin hvis du har brug for at se denne information."
    : "Denne side er kun tilgængelig for superadmins. Kontakt en superadmin hvis du har brug for at se denne information.";

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-secondary flex items-center justify-center mb-5">
          <Lock className="w-7 h-7 text-muted-foreground" />
        </div>
        <h1 className="text-xl font-bold text-foreground mb-2">{title || "Adgang begrænset"}</h1>
        <p className="text-sm text-muted-foreground mb-6 leading-relaxed">{message || defaultMsg}</p>
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl border border-border bg-secondary hover:bg-secondary/80 text-sm font-medium transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Tilbage
        </button>
      </div>
    </div>
  );
}
